import * as React from "react";

import { Link, makeStyles, Theme } from "@material-ui/core";

import { useBranding, useTranslation } from "client/hooks";
import { logAmplitudeEvent } from "client/lib/amplitude";
import { Product } from "client/lib/apt-merchant";

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    color: theme.palette.info.main,
  },
}));

interface PrivacyPolicyLinkProps {
  product?: Product;
}

export const PrivacyPolicyLink: React.FC<PrivacyPolicyLinkProps> = ({
  product = "Afterpay",
}) => {
  const classes = useStyles();
  const t = useTranslation();
  const { brandTitle, brandKey } = useBranding();
  const isCash = brandKey === "CashApp";

  const href = t("uiAfterpayPrivacyPolicyUrl");

  return (
    <Link
      className={isCash ? "" : classes.link}
      href={href}
      rel="noopener noreferrer"
      underline={isCash ? "always" : "hover"}
      target="_blank"
      onClick={() => {
        product === "Cash"
          ? logAmplitudeEvent("CASH_PAY_FORM", "cash_pay_privacy_policy_opened")
          : logAmplitudeEvent(
              "REDESIGN_ADD_YOUR_STORE",
              "merchant_privacy_policy_opened"
            );
      }}
    >
      {product === "Cash"
        ? `${brandTitle}'s ${t("uiMerchantPrivacyPolicy")}`
        : t("uiMerchantPrivacyPolicy")}
    </Link>
  );
};
